import {
    Body,
    ClockSvg,
    CloseBorderSvg,
    colors,
    ConfirmationSvg,
    HourglassSvg,
    Icon,
    InProgressSvg,
    Spacer,
} from '@spritz-finance/ui'
import { BadgeContainer } from '../../../../components/badges/BadgeContainer'
import { PaymentStatus } from '../../../../graphql/generated/graphql'
import { cssVar } from '../../../../theme/utils'

const useBadgeConfig = (status: PaymentStatus) => {
    const STATUS_BADGE_CONFIG: Record<
        PaymentStatus,
        { icon: React.ReactElement; label: string; color: string; background: string }
    > = {
        [PaymentStatus.Cancelled]: {
            icon: (
                <Icon
                    size={16}
                    icon={CloseBorderSvg}
                    tint={cssVar('--text-primary', colors.coral[75])}
                />
            ),
            label: 'Cancelled',
            background: colors.coral[50],
            color: colors.coral[75],
        },
        [PaymentStatus.Failed]: {
            icon: (
                <Icon
                    size={16}
                    icon={CloseBorderSvg}
                    tint={cssVar('--text-primary', colors.coral[75])}
                />
            ),
            label: 'Failed',
            background: colors.coral[50],
            color: colors.coral[75],
        },
        [PaymentStatus.Scheduled]: {
            icon: (
                <Icon
                    size={16}
                    icon={InProgressSvg}
                    tint={cssVar('--text-primary', colors.sunny[75])}
                />
            ),
            label: 'Scheduled',
            background: colors.sunny[50],
            color: colors.sunny[75],
        },
        [PaymentStatus.Sent]: {
            icon: (
                <Icon
                    size={16}
                    icon={InProgressSvg}
                    tint={cssVar('--text-primary', colors.sunny[75])}
                />
            ),
            label: 'Sent',
            background: colors.sunny[50],
            color: colors.sunny[75],
        },
        [PaymentStatus.Pending]: {
            icon: (
                <Icon
                    size={16}
                    icon={InProgressSvg}
                    tint={cssVar('--text-primary', colors.sunny[75])}
                />
            ),
            label: 'In progress',
            background: colors.sunny[50],
            color: colors.sunny[75],
        },
        [PaymentStatus.Completed]: {
            icon: (
                <Icon
                    size={16}
                    icon={ConfirmationSvg}
                    tint={cssVar('--text-primary', colors.seaSpray[75])}
                />
            ),
            label: 'Completed',
            background: colors.seaSpray[50],
            color: colors.seaSpray[75],
        },
        [PaymentStatus.Refunded]: {
            icon: (
                <Icon
                    size={16}
                    icon={CloseBorderSvg}
                    tint={cssVar('--text-primary', colors.coral[75])}
                />
            ),
            label: 'Refunded',
            background: colors.coral[50],
            color: colors.coral[75],
        },
        [PaymentStatus.Reversed]: {
            icon: (
                <Icon
                    size={16}
                    icon={CloseBorderSvg}
                    tint={cssVar('--text-primary', colors.coral[75])}
                />
            ),
            label: 'Refunded',
            background: colors.coral[50],
            color: colors.coral[75],
        },
        [PaymentStatus.ReversalInProgress]: {
            icon: (
                <Icon
                    size={16}
                    icon={CloseBorderSvg}
                    tint={cssVar('--text-primary', colors.coral[75])}
                />
            ),
            label: 'Refunded',
            background: colors.coral[50],
            color: colors.coral[75],
        },
    }

    return STATUS_BADGE_CONFIG[status]
}

export const StatusBadge = ({ status }: { status: PaymentStatus }) => {
    const { label, color, background, icon } = useBadgeConfig(status)
    return (
        <BadgeContainer $visible={true} $background={cssVar('--surface-3', background)}>
            {icon}
            <Spacer width={4} />
            <Body.SmBold size={10} color={cssVar('--text-primary', color)}>
                {label}
            </Body.SmBold>
        </BadgeContainer>
    )
}
